function Adoptable(props) {
    return (
        <div className='adoptable'>
        <div id = 'adopt-details'>
          <p>click my eggs boy</p>
        </div>
        <div id = 'adopt-container'>
          <div className='little-guy'>
            <a href="https://dragcave.net/view/RO8T3"><img src="https://dragcave.net/image/RO8T3.gif" style={{borderWidth: 0, maxHeight:'40px'}} alt="Dragon Cave: Adopt one today!"/></a>
            <p>Walmartholemew II</p>
            </div>
          <div className='little-guy'>
            <a href="https://dragcave.net/view/Pxy0M"><img src="https://dragcave.net/image/Pxy0M.gif" style={{borderWidth: 0, maxHeight:'40px'}} alt="Dragon Cave: Adopt one today!"/></a>
            <p>Melon Soda</p>
            </div>
          <div className='little-guy'>
            <a href="https://finaloutpost.net/view/bhTC4/"><img src="https://finaloutpost.net/s/bhTC4.png" style={{borderWidth: 0, maxHeight:'40px'}} /></a>
            <p>BITCH</p>
          </div>
          <div className='little-guy'>
            <a href="https://finaloutpost.net/view/6TA0I/"><img src="https://finaloutpost.net/s/6TA0I.png" style={{borderWidth: 0, maxHeight:'40px'}} /></a>
            <p>6YAOI</p>
          </div>
        </div>
        <button id='hatchery-btn' onClick={()=>props.handlePages("hatchery")}>Feed more beasts</button>

      </div>
    );
  }

  export default Adoptable;